import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * PurchaseSuccess
 * A placeholder success page for Phase-1. It simply confirms that the user
 * has returned from Stripe Checkout. In later phases we will fetch the
 * purchase record via the session_id query parameter to show more detail.
 */
function PurchaseSuccess() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const sid = params.get('session_id');
    if (sid) {
      setSessionId(sid);
    }
  }, [search]);

  const goToDashboard = () => {
    navigate('/dashboard', { replace: true });
    // Ensure fresh data
    window.location.reload();
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '80vh',
      padding: '1.5rem',
      backgroundColor: 'var(--surface-bg)',
      fontFamily: 'var(--font)'
    }}>
      <div style={{
        background: 'var(--surface-card)',
        borderRadius: '16px',
        border: '1px solid var(--border-subtle)',
        padding: '3rem 2rem',
        maxWidth: '520px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 10px 30px rgba(32,32,32,0.08)'
      }}>
        {/* Minimal checkmark icon */}
        <div style={{
          width: '64px',
          height: '64px',
          borderRadius: '50%',
          backgroundColor: '#d4edda',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1.5rem'
        }}>
          <span style={{ fontSize: '2rem', color: '#2e7d32' }}>✓</span>
        </div>
        <h2 style={{ margin: '0 0 1rem', color: '#2e7d32', fontSize:'1.75rem', fontWeight:'700' }}>Payment Successful</h2>
        <p style={{ margin: '0 0 1.5rem', color: 'var(--text-muted)', lineHeight: 1.5 }}>
          Thank you for your purchase. Your payment has been processed and is pending seller confirmation.
          You can view the details on your dashboard.
        </p>
        {sessionId && (
          <p style={{ fontSize: '0.8rem', color: 'var(--text-soft)', marginBottom: '2rem' }}>Session ID: {sessionId}</p>
        )}
        <button
          onClick={goToDashboard}
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: 'var(--maroon)',
            color: '#fff',
            border: 'none',
            borderRadius: '10px',
            fontSize: '1rem',
            fontWeight: 600,
            fontFamily: 'var(--font-heading)',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease'
          }}
          onMouseOver={e=>e.currentTarget.style.backgroundColor = 'var(--maroon-hover)'}
          onMouseOut={e=>e.currentTarget.style.backgroundColor = 'var(--maroon)'}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}

export default PurchaseSuccess; 